import styled from '@emotion/styled'
import { Box } from '@mui/material'
import theme from 'theme'

export const Wrapper = styled(Box)`
  border: 1px solid ${theme.colors.strokePrimary};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 64px ${theme.spacing.medium}px;

  @media (min-height: 801px) {
    min-height: 544px;
  }

  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .title {
      margin-top: ${theme.spacing.large}px;
      color: ${theme.colors.foreground};
      font-family: ${theme.typography.fontFamily.primary};
      font-size: ${theme.typography.fontSize.xxxLarge};
      font-style: normal;
      font-weight: ${theme.typography.fontWeight.bold};
      line-height: normal;
      margin-bottom: ${theme.spacing.xSmall}px;
    }

    .description {
      color: ${theme.colors.foreground};
      font-size: ${theme.typography.fontSize.xLarge};
      font-style: normal;
      font-weight: ${theme.typography.fontWeight.normal};
      line-height: normal;
      text-align: center;

      .colored {
        color: ${theme.colors.cta};
        display: inline-block;
        margin-left: 3px;
        margin-right: 3px;
      }
    }
  }
`

export const InstancesEmptyWrapper = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: calc(100vh - 330px);

  .content {
    display: flex;
    flex-direction: column;
    align-items: center;

    .title {
      margin-top: ${theme.spacing.large}px;
      margin-bottom: ${theme.spacing.md}px;
      color: ${theme.colors.menuItemText};
      font-family: ${theme.typography.fontFamily.primary};
      font-size: ${theme.typography.fontSize.xxxLarge};
      font-weight: ${theme.typography.fontWeight.bold};
      line-height: normal;
    }

    .description {
      color: ${theme.colors.devicesSecondaryText};
      font-family: ${theme.typography.fontFamily.primary};
      font-size: ${theme.typography.fontSize.xLarge};
      font-weight: ${theme.typography.fontWeight.normal};
      line-height: 24px;
      text-align: center;
      max-width: 396px;
    }
  }
`
